import { PetSafeProduct } from '@model/product/product.model';

export enum HopperStatus {
  GOOD,
  EMPTY,
  LOW,
  OTHER,
}

export interface Smartfeed extends PetSafeProduct {
  thingName: string;
  batteryVoltage: number;
  connectionStatus: 0 | 1 | 2 | 3;
  hopperStatus: HopperStatus; // is_food_low
  adapterStatus: 0 | 1; // is_adapter_installed
  batteriesStatus: 0 | 1; // is_batteries_installed
  firmwareVersion: string;
  productVersion: 1 | 2;
  revisionDesired: number;
  revisionReported: number;
  foodSensorCurrent: number;
  foodSensorReference: number;
  networkRssi: number;
  networkSnr: number;
  connectionStatusTimestamp: Date;
  createdAt: Date;
  updatedAt: Date;
  deletedAt: Date;
  updatedBy: string;
  createdBy: string;
  inventory?: number;
  feederId?: string;
  userId?: number;
  messages?: Array<SmartfeedMessage>;
  schedules?: Array<SmartfeedSchedule>;
  settings?: SmartfeedSettings;
}

export interface SmartfeedSettings {
  feederId: number;
  friendlyName: string;
  isChildLockOn: 0 | 1;
  isSchedulePaused: 0 | 1;
  isSlowFeedEnabled: 0 | 1;
  notifyOnCommunityMessage: 0 | 1;
  notifyOnConnectionStateChange: 0 | 1;
  notifyOnEmptyFood: 0 | 1;
  notifyOnError: 0 | 1;
  notifyOnFeed: 0 | 1;
  notifyOnLowFood: 0 | 1;
  petType?: string;
  timezone: string;
  createdAt: Date;
  updatedAt: Date;
}

export interface SmartfeedMessage {
  messageId: string;
  feedersId: string;
  messageType: string;
  payload?: unknown;
  createdAt?: string;
  updatedAt?: string;
}

export interface SmartfeedSchedule {
  scheduleId: string;
  feederId: string;
  amount: number;
  time: string;
  createdAt?: string;
  updatedAt?: string;
}
